<template>
	<v-dialog
		v-model="dialog"
		max-width="800"
		persistent
		@input="$emit('input', $event)"
	>
		<v-card :loading="loading">
			<v-progress-linear indeterminate v-if="loading"></v-progress-linear>
			<v-layout>
				<v-card-title class="headline">{{
					title == null ? "Warning" : title
				}}</v-card-title>

				<v-spacer />

				<v-btn icon @click="cancelClick">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-layout>
			<v-container>
				<alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
			</v-container>
			<v-card-text v-if="text">{{ text }}</v-card-text>
			<v-container>
				<slot></slot>
			</v-container>

			<v-card-actions v-if="!noActions">
				<btn-a
					v-if="deleteButton && confirmation == null"
					class="start"
					color="error"
					@click="deleteClick"
					:disable="loading"
					:access="accessDelete"
					>Delete</btn-a
				>
				<v-spacer />
				<div class="mr-2">
					<btn-a
						class="mr-2"
						v-if="confirmation == null"
						outlined
						@click="cancelClick"
						:disable="loading"
						>{{ $t("cancel") }}</btn-a
					>
				</div>
				<div>
					<btn-a
						color="primary"
						outlined
						@click="confirmClick"
						:disable="loading"
						:access="accessConfirm"
						>{{ $t("confirm") }}</btn-a
					>
				</div>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			value: {},
			title: {},
			deleteButton: {},
			text: {},
			loading: {},
			confirmation: {},
			accessConfirm: {},
			accessDelete: {},
			cancelConfirm: {},
			noActions: {
				default() {
					return false;
				},
			},
			alert: {
				default() {
					return {
						alerts: [],
						type: "error",
					};
				},
			},
		},
		data() {
			return {
				dialog: false,
			};
		},
		watch: {
			value() {
				this.dialog = this.value;
			},
		},
		methods: {
			open() {
				this.dialog = !this.dialog;
			},
			alertClose() {
				this.$emit("alertClose");
			},
			deleteClick() {
				this.$emit("delete");
			},
			confirmClick() {
				this.$emit("confirm");
			},
			async cancelClick() {
				//if (this.cancelConfirm != null) {

				if (this.alert.alerts.length > 0) this.alert.alerts = [];

				let res = await this.$confirm(null, this.$t("cancel") + "?");
				if (!res) return;
				//}
				this.dialog = false;
				this.$emit("cancel");
			},
		},
		mounted() {
			//console.log(this.value);
			this.dialog = this.value;
		},
	};
</script>
